export default "__VITE_ASSET__DO20rZko__"